/* Public site-specific initialization. Loaded by public-core.js. */
document.addEventListener('DOMContentLoaded', () => {
  const meta = document.querySelector('meta[name="csrf-token"]');
  if (meta && window.jQuery) {
    window.jQuery.ajaxSetup({ headers: { 'X-CSRF-TOKEN': meta.content } });
  }

  /* Intro overlay fade-out (controlled by IntroSetting) */
  const overlay = document.querySelector('.almc-intro-overlay');
  if (overlay) {
    const duration = parseInt(overlay.dataset.duration || '3500', 10);
    setTimeout(() => overlay.classList.add('fading'), duration);
    setTimeout(() => overlay.remove(), duration + 600);
  }
});
